import { fetchRoomIdForAgentId } from '#~/api/agent/index.js';
import { useAuth0 } from '#~/auth/index.js';
import { isElectronApp } from '#~/electron/utils.js';
import { NotFoundError } from '#~/error/index.js';
import { Paths } from '#~/routes/index.js';
import type { Props } from './types.js';
import { unwrap } from '@studio/js-utils/async';
import { normalizeId } from '@studio/models';
import type { Agent as M_Agent } from '@studio/models/agent';
import { useAsyncEffect } from '@studio/react-utils/hooks';
import { useEffect, useState } from 'react';
import type { ReactElement } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TimeoutWatchdog } from './timeout-watchdog.js';

/** `<AgentLookup>` route. */
export const AgentLookup = (_props: Props): ReactElement => {
  const params = useParams();

  const agentId = normalizeId<M_Agent['id']>(params.agentId);
  const { getAccessTokenSilently } = useAuth0();
  const [error, setError] = useState<boolean>();

  const navigate = useNavigate();

  useEffect(() => {
    if (!agentId) {
      throw new NotFoundError();
    }

    if (error) {
      navigate('/');
    }
  }, [error, agentId]);

  useAsyncEffect(
    function* generator(_signal: AbortSignal) {
      const token: string = yield* unwrap(getAccessTokenSilently());

      if (!agentId) {
        setError(true);
      }

      try {
        const roomId = yield* unwrap(fetchRoomIdForAgentId(agentId!, token));

        if (!roomId) {
          throw new NotFoundError();
        }

        /*navigate(isElectronApp()
          ? Paths.room.boot.resolve(roomId)
          : Paths.room.resolve(roomId));*/
        window.location.href = isElectronApp()
          ? Paths.room.boot.resolve(roomId)
          : Paths.room.resolve(roomId);
      } catch {
        setError(true);
      }
    },
    [agentId, navigate]
  );

  if (!agentId) {
    return <> </>;
  }

  return <TimeoutWatchdog agentIDs={[agentId]} />;
};
